// "Learn more" for the onboarding CI invitation: the full disclosure for one option, read-only.
// Opening it is voluntary and never required for a choice.
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { IVORY } from './ciInviteCopy';

export const CIConsentSheet = ({ tier, onClose, ci, copy }) => (
  <Dialog open={!!tier} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="ci-sheet"
      className="max-h-[88dvh] max-w-lg overflow-y-auto border-0 p-6 sm:p-7 [&>button]:hidden"
      style={{ background: '#0B0E1A', color: IVORY, boxShadow: '0 30px 80px rgba(0,0,0,0.65)', borderRadius: 24 }}>
      {tier && (
        <>
          <DialogTitle className="text-[1.3rem] font-semibold" style={{ color: IVORY }}>{copy[tier].title}</DialogTitle>
          <DialogDescription className="text-[0.9rem] leading-relaxed" style={{ color: 'rgba(244,239,231,0.78)' }}
            data-testid={`ci-sheet-${tier}-details`}>
            {ci[tier].body}
          </DialogDescription>
          <p className="text-[0.84rem] leading-relaxed" style={{ color: 'rgba(244,239,231,0.6)' }}>{ci.shared}</p>
          <p className="text-[0.84rem] leading-relaxed" style={{ color: 'rgba(244,239,231,0.6)' }}>{copy.info}</p>
          <div>
          <button type="button" onClick={onClose} data-testid="ci-sheet-close"
            className="mt-2 h-12 w-full rounded-full text-[0.95rem] font-semibold"
            style={{ color: IVORY, border: '1px solid rgba(244,239,231,0.22)' }}>
            {copy.close}
          </button>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);

export default CIConsentSheet;
